import { all, call, fork, put, select, takeLatest, cancelled, getContext } from 'redux-saga/effects';
import { IIntakeIdWithDates, ISystemAndUniConfig } from 'api-paths-cas';
import { getFiltersFailure, getFiltersSuccess } from '../actions';
import { DashboardActionTypes } from '../types';
import { logout } from '../../auth/actions';
import { getAuth, getConfig, getInstitution, getIntakeId, getIntakeRange, getUniId } from '../../selectors';
import isTesting from '../../../utilities/isTesting';
import { getAllFilters } from '../../../api/api';
import { INTAKE_ALL_END_DATE, INTAKE_ALL_START_DATE } from '../../../utilities/constants';
import { shouldSetUniFromState } from './helpers';
import { AuthState, UserRole } from '../../auth/types';
import { hasPerm, P } from '../../../utilities/roles/permissions';

export let getAllStudentFiltersAbortController: AbortController;

export function* handleGetAllFilters(): any {
  let res: any;
  const auth: AuthState = yield select(getAuth);
  const config: ISystemAndUniConfig = yield select(getConfig);
  const institution: string = yield select(getInstitution);
  const uni: string = shouldSetUniFromState(auth.role) ? yield select(getUniId) : undefined;
  const intakeId: string = yield select(getIntakeId);
  const intakeRange: IIntakeIdWithDates | undefined = yield select(getIntakeRange, intakeId);
  const startDate = intakeRange?.startDate ?? INTAKE_ALL_START_DATE;
  const endDate = intakeRange?.endDate ?? INTAKE_ALL_END_DATE;
  const context = yield getContext('sagaContext');
  const idToken: any = yield call(context.getIdToken);
  const isPathway = config.isPathway ?? false;

  if (uni && !intakeId && !isTesting) {
    yield put(getFiltersFailure('No intake Id provided.'));
    return;
  }

  if (!idToken) {
    yield put(logout());
    yield call(context.onLogout);
    console.log('Refresh Token has Expired - handleGetAllFilters');
    return;
  }

  const canViewIncludeStudentDropdown = !!(
    config.relatedPathways?.length &&
    hasPerm(auth.role, P.VIEW_INSTITUTION_DROPDOWN) &&
    !(
      [UserRole.UniAdmin, UserRole.Uni, UserRole.UniSecure, UserRole.UniLite].includes(auth.role) &&
      auth.pathwayAccess === 'None'
    )
  );
  getAllStudentFiltersAbortController = new AbortController();
  try {
    //@ts-ignore
    res = yield call(getAllFilters, {
      abortController: getAllStudentFiltersAbortController,
      idToken,
      ...(isPathway ? { pathway: uni } : { uni }),
      intakeId,
      institution: canViewIncludeStudentDropdown ? institution : '',
      startDate,
      endDate,
    });
  } catch (err) {
    if (err instanceof Error) {
      yield put(getFiltersFailure(err.message));
    } else {
      yield put(getFiltersFailure('An unknown error occured.'));
    }
    return;
  } finally {
    if (yield cancelled()) {
      // the task was cancelled
      getAllStudentFiltersAbortController.abort();
      return;
    }
  }
  yield put(getFiltersSuccess(res));
}

function* watchGetFilters() {
  yield takeLatest(DashboardActionTypes.GET_FILTERS, handleGetAllFilters);
}

function* GetFiltersSaga() {
  yield all([fork(watchGetFilters)]);
}

export default GetFiltersSaga;
